import { Component, output, input, ChangeDetectionStrategy } from '@angular/core';

import { IconComponent } from '../icon/icon.component';
import { RtTooltip } from '../tooltip/tooltip.directive';

@Component({
  selector: 'rt-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, RtTooltip],
})
export class ChipsComponent {
  public readonly text = input.required<string>();
  public readonly showClose = input<boolean>(true);
  public readonly tooltip = input('');

  public close = output<MouseEvent>();
}
